export const PermanentRedirectErrorCode = 301

export default class PermanentRedirectError extends Error {
  type = PermanentRedirectErrorCode
  host: string
  url: string

  constructor(url = '/', host: string, e = 'Redirection permanente') {
    super(e)
    this.name = 'Moved Permamently'
    this.type = PermanentRedirectErrorCode
    this.url = url
    this.host = host
  }
}
